import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from './componenets/PageHero';
import Reveal from './componenets/Reveal';

export const Training = () => (
  <div className="site-page">
    <PageHero eyebrow="Opportunities" title="Training and Education" description="Training for volunteers and community members supporting funeral and burial services." image="/images/HomeSlider_7.jpg" compact />
    <section className="site-section"><div className="site-container resource-layout">
      <Reveal className="resource-layout__copy"><p className="site-eyebrow">Training</p><h2>Training Opportunities</h2><p>Garden of Peace offers educational opportunities for community members interested in funeral, burial, and family support.</p><Link className="site-button" to="/contactus">Ask about training</Link></Reveal>
      <Reveal className="resource-poster" delay={100}><img src="/images/Training.jpg" alt="Garden of Peace training and education information" /></Reveal>
    </div></section>
  </div>
);
